import React from 'react'
import { connect } from 'react-redux'
import { Flex, Box } from 'reflexbox'
import uniqBy from 'lodash/uniqBy'
import * as BP from '@blueprintjs/core'
import CustomerSelect from 'src/components/CustomerSelect'
import { getCustomerById } from 'src/store/modules/cmdb/customers'
import * as solutionModules from 'src/store/modules/cmdb/solutions'

class Solutions extends React.Component {
    handleSolutionSelect = (customer) => {
        this.props.onCustomerSelect(customer.id)
        this.props.fetchCustomerSolutions(customer.id)
    }
    handleClear = () => {
        this.props.onCustomerSelect(null)
    }
    handleSaveClick = () => {
        this.props.saveCustomerSolutions(this.props.selectedCustomer.id)
    }
    computeSolutionStats() {
        const { solutionsMap, selectedCustomer } = this.props
        if (!selectedCustomer) {
            return <p>No customer selected</p>
        }
        const solutionsList = Object.keys(solutionsMap)
        const total = solutionsList.length
        const totalSolutions = solutionsList.filter(
            (s) => solutionsMap[s].solution
        ).length
        const classes = uniqBy(
            solutionsList.map((s) => solutionsMap[s]),
            'cmdb_class'
        ).length
        return (
            <React.Fragment>
                <h2 style={{ marginTop: 0 }}>{selectedCustomer.name}</h2>
                <p>{total} devices</p>
                <p>{totalSolutions} solutions</p>
                <p>{classes} device classes</p>
            </React.Fragment>
        )
    }
    render() {
        const { selectedCustomer, loading, status } = this.props
        return (
            <Flex w={1} wrap>
                <Box w={1} p={2}>
                    <CustomerSelect
                        selected={selectedCustomer}
                        onCustomerSelect={this.handleSolutionSelect}
                    />
                </Box>
                <Box w={1} p={2}>
                    {loading ? (
                        <BP.Spinner />
                    ) : (
                        <BP.Card>
                            {this.computeSolutionStats()}
                            <BP.Button
                                loading={status === 'saving'}
                                disabled={!selectedCustomer}
                                icon={
                                    status === 'success'
                                        ? 'tick'
                                        : status === 'error'
                                        ? 'cross'
                                        : null
                                }
                                text="Save to database"
                                onClick={this.handleSaveClick}
                            />
                            <BP.Button
                                style={{ marginLeft: 10 }}
                                disabled={!selectedCustomer}
                                text="Clear Selection"
                                onClick={this.handleClear}
                            />
                        </BP.Card>
                    )}
                </Box>
            </Flex>
        )
    }
}

export default connect(
    (state) => ({
        selectedCustomer: getCustomerById(
            state,
            state.cmdb.solutions.selectedCustomer
        ),
        solutionsMap: state.cmdb.solutions.solutionsMap,
        topSolutions: state.cmdb.solutions.topSolutions,
        loading: state.cmdb.solutions.loading,
        status: state.cmdb.solutions.status,
    }),
    {
        onCustomerSelect: (customerId) =>
            solutionModules.selectCmdbSolutionCustomer(customerId),
        fetchCustomerSolutions: (customerId) =>
            solutionModules.fetchCmdbSolutions(customerId),
        saveCustomerSolutions: (customerId) =>
            solutionModules.saveCmdbSolutions(customerId),
    }
)(Solutions)
